import { cidadesRecomendadas } from "@/services/pagesWeb";
import { CidadesAtendidas } from "@/types/Endereco";
import { regions } from "@/utils/locales";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { LuMapPinCheckInside } from "react-icons/lu";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import ImageSvg from "../ui/image-svg";

export const CidadesAtendidasSection = ({
  stateName,
  codeState,
  cityName,
}: {
  stateName: string;
  codeState: string;
  cityName?: string;
}) => {
  const [cidadesAtendidas, setcidadesAtendidas] = useState<CidadesAtendidas[]>(
    [],
  );

  useEffect(() => {
    const fetchEndereco = async () => {
      const cidadeAtual = regions
        .flatMap((region) => region.cities)
        .find(
          (city) =>
            city.name.toLowerCase() === cityName.toLowerCase() &&
            city.state.toLowerCase() === stateName.toLowerCase(),
        );

      if (!cidadeAtual) {
        throw new Error("Cidade não encontrada");
      }

      try {
        const response = await cidadesRecomendadas(cidadeAtual.id);
        setcidadesAtendidas(response);
      } catch {
        // silently fail
      }
    };

    fetchEndereco();
  }, [cityName, stateName]);

  return (
    <section id="cidades-atendidas" className=" py-10 md:py-24 bg-n-bg-green">
      <div className="container">
        <div className=" grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="mb-5 text-n-beige text-3xl font-medium md:mb-6 md:text-4xl lg:text-5xl">
              Outras bases na {stateName}
            </h2>
            <p className="mt-4 text-n-text-light font-light md:text-lg">
              A Nacional GO oferece serviços de transporte de veículos em{" "}
              {cityName} e em diversas cidades da região metropolitana e
              interior da {stateName}. Nossa base operacional está
              estrategicamente localizada para garantir agilidade e eficiência
              no atendimento.
            </p>

            <div className="mt-6 grid grid-cols-2 gap-2 text-xs md:text-sm">
              {cidadesAtendidas.map((city, index) => (
                <span key={index} className="text-n-text-light flex gap-3 py-1">
                  <LuMapPinCheckInside className="text-lg text-n-secondary" />
                  {city.origem}
                </span>
              ))}
            </div>

            <p className="mt-8 text-n-beige font-light md:text-lg">
              A Nacional GO possui mais de 200 bases no Brasil
            </p>

            <Link to="/fazer-cotacao">
              <Button
                id="btn-fazer-cotacao"
                variant="outline"
                size="lg"
                className="border-0 px-0 mt-2 hover:bg-transparent hover:text-n-beige"
              >
                Agendar meu transporte <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          {/* Imagem mapa ilustrativo */}
          <div className="flex items-center justify-center px-10">
            <ImageSvg
              src={`/cities/${codeState.toLowerCase()}-iso.svg`}
              alt={`Outras bases na ${stateName}`}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
